import * as React from 'react'
import './style/jobs.scss'
import classnames from 'classnames'
import { Radio, Tabs } from 'antd'
import { PageHeader } from '@pushly/aqe/lib/components'
import { noop } from '@pushly/aqe/lib/utils/noop'
import JobsList from '@halo/components/jobs-list/jobs-list'
import JobSchedulesList from '@halo/components/job-schedules-list/job-schedules-list'
import TabbedView from '@halo/components/tabbed-view/tabbed-view'
import { observer } from 'mobx-react'
import { useService } from '@halo/hooks/use-service'
import { AppState } from '@halo/stores/app.state'
import { AppService } from '@halo/services/app.service'
import { useUserPreferences } from '@pushly/aqe/lib/providers/user-preferences-provider/core/index'

const Jobs = observer(() => {
    const appState = useService<AppState>(AppState)
    const appService = useService<AppService>(AppService)
    const userPreferences = useUserPreferences(appState.currentUser.id)

    return (
        <div className={classnames('page', 'dev-jobs')}>
            <div className={classnames('page-wrapper')}>
                <PageHeader title="Jobs" onTitleSet={noop} />

                <TabbedView
                    size="small"
                    animated={false}
                    destroyInactiveTabPane={true} // kills auto-refresh
                    hideAdd={true}
                    availablePathKeys={['schedules']} // 'jobs' is the root path
                    defaultActiveKey={'jobs'}
                    tabBarExtraContent={
                        <div className="jobs-dtz-toggle">
                            <span>Time Zone Display: </span>
                            <Radio.Group
                                className="iter-utc-toggle"
                                size="small"
                                buttonStyle="solid"
                                value={userPreferences.get(['display_time_zone']) !== 'UTC' ? 'local' : 'utc'}
                                onChange={(ev) => {
                                    const useLocal = ev.target.value === 'local'
                                    userPreferences.set(['display_time_zone'], useLocal ? 'America/Chicago' : 'UTC')
                                }}
                            >
                                <Radio.Button value="utc">UTC</Radio.Button>
                                <Radio.Button value="local">Local</Radio.Button>
                            </Radio.Group>
                        </div>
                    }
                >
                    <Tabs.TabPane key="jobs" tab="Recent Jobs">
                        <JobsList />
                    </Tabs.TabPane>
                    <Tabs.TabPane key="schedules" tab="Job Schedules">
                        <JobSchedulesList />
                    </Tabs.TabPane>
                </TabbedView>
            </div>
        </div>
    )
})

export default Jobs
